import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107110Status: 'idle',
    startProcess107110Error: undefined as any,
    loadUserParamsProcess107110Status: 'idle',
    loadUserParamsProcess107110Error: undefined as any,

    process107110List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107110 = createAsyncThunk('process107110Slice/startProcess107110', async ({ process107110 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107110/`,
        prepareData(process107110),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107110Status } = getState().process107110Slice
        return startProcess107110Status !== 'pending'
    }
})

export const loadUserParamsProcess107110 = createAsyncThunk('process107110Slice/loadUserParamsProcess107110', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107110/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107110Status } = getState().process107110Slice
        return loadUserParamsProcess107110Status !== 'pending'
    }
})

const Process107110Slice = createSlice({
    name: 'process107110Slice',
    initialState,
    reducers: {
        resetstartProcess107110: (state) => {
            state.job = undefined
            state.startProcess107110Error = undefined
        },
        resetstartProcess107110Error: (state) => {
            state.startProcess107110Error = undefined
        },
        resetloadUserParamsProcess107110: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107110Error = undefined
        },
        resetloadUserParamsProcess107110Error: (state) => {
            state.loadUserParamsProcess107110Error = undefined
        },
        removeFromProcess107110ListById: (state, action) => {
            state.process107110List = state.process107110List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107110ListByIds: (state, action) => {
            state.process107110List = state.process107110List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107110List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107110Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107110List = []
            state.startProcess107110Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107110.pending, (state) => {
            state.startProcess107110Status = 'pending'
            state.startProcess107110Error = undefined
        })
        builder.addCase(startProcess107110.fulfilled, (state, action) => {
            state.startProcess107110Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107110.rejected, (state, action) => {
            state.startProcess107110Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107110Error = action.error.message
            } else {
                state.startProcess107110Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107110.pending, (state) => {
            state.loadUserParamsProcess107110Status = 'pending'
            state.loadUserParamsProcess107110Error = undefined
        })
        builder.addCase(loadUserParamsProcess107110.fulfilled, (state, action) => {
            state.loadUserParamsProcess107110Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107110.rejected, (state, action) => {
            state.loadUserParamsProcess107110Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107110Error = action.error.message
            } else {
                state.loadUserParamsProcess107110Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107110,
    resetstartProcess107110Error,
    resetloadUserParamsProcess107110,
    resetloadUserParamsProcess107110Error,
    removeFromProcess107110ListById,
    removeFromProcess107110ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107110Slice.actions
export default Process107110Slice.reducer
